import { CtaSection } from './components/CtaSection';
import { FilterableLocations } from './components/FilterableLocations';
import { MostVisitedLocationSection } from './components/MostVisitedLocationSection';

export function PageBody() {
	return (
		<>
			<FilterableLocations />
			<MostVisitedLocationSection />
			<CtaSection />
		</>
	);
}
